import { AppAlerts } from '@infl-ts/ui-app-alerts';
import { GlobalChallengePlayer } from '@infl-ts/ui-global-challenge-player';
import { EmbedShadowRoot } from '@infl-ts/ui-shadow-dom';
import { wrapIntoFragment } from '@infl-ts/ui-wrap-into-fragment';
import { AppConfigProvider, hasMode, Modes } from '@infl-ts/util-app-config';
import { DE$ } from '@infl-ts/util-datum';
import { S$ } from '@infl-ts/util-fp-ts';
import { Freezer } from '@infl-ts/util-freezer';
import { GlobalStickyOffset } from '@infl-ts/util-global-sticky-offset';
import { I18nProvider } from '@infl-ts/util-i18n-provider';
import { PopoverConfigProvider } from '@infl-ts/util-popover-config';
import * as DE from '@nll/datum/lib/DatumEither';
import { constFalse, constTrue, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import QueryAlerts from '../../lib/query-alerts';
import PageBlockList from './page-block-list';
import { SetupTheme } from './setup-theme';
import { jsx as _jsx } from "react/jsx-runtime";
export var Page = function Page(_ref) {
  var siteConfig = _ref.siteConfig,
      leafBlocks = _ref.leafBlocks,
      cookieLang = _ref.cookieLang,
      defaultLocales = _ref.defaultLocales,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? wrapIntoFragment : _ref$children;
  return /*#__PURE__*/_jsx(SetupTheme, {
    siteConfig: siteConfig,
    "data-element": "SetupTheme",
    "data-component": "Page",
    "data-source-file": "page.tsx",
    children: /*#__PURE__*/_jsx(AppAlerts, {
      "data-element": "AppAlerts",
      "data-component": "Page",
      "data-source-file": "page.tsx",
      children: /*#__PURE__*/_jsx(AppConfigProvider, {
        options: pipe(siteConfig, DE.map(function (siteConfig) {
          return siteConfig.configs.appConfig;
        })),
        "data-element": "AppConfigProvider",
        "data-component": "Page",
        "data-source-file": "page.tsx",
        children: /*#__PURE__*/_jsx(I18nProvider, {
          options: pipe(siteConfig, DE.map(function (siteConfig) {
            return siteConfig.configs.multilingualConfig;
          })),
          defaultLocales: defaultLocales,
          cookieLang: cookieLang,
          pageRequiresConsent: pipe(siteConfig, DE.map(S$.prop('consentRequired')), DE$.getSuccessOrElse(true)),
          isPublicPage: pipe(siteConfig, DE$.squashRefresh(constTrue, constTrue, constFalse, function (_ref2) {
            var appConfig = _ref2.configs.appConfig;
            return pipe(appConfig, O.match(constFalse, hasMode(Modes.map["public"])));
          })),
          "data-element": "I18nProvider",
          "data-component": "Page",
          "data-source-file": "page.tsx",
          children: /*#__PURE__*/_jsx(QueryAlerts, {
            "data-element": "QueryAlerts",
            "data-component": "Page",
            "data-source-file": "page.tsx",
            children: /*#__PURE__*/_jsx(PopoverConfigProvider, {
              popoverConfig: pipe(siteConfig, DE.map(function (siteConfig) {
                return siteConfig.configs.popoverConfig;
              })),
              "data-element": "PopoverConfigProvider",
              "data-component": "Page",
              "data-source-file": "page.tsx",
              children: /*#__PURE__*/_jsx(GlobalStickyOffset, {
                "data-element": "GlobalStickyOffset",
                "data-component": "Page",
                "data-source-file": "page.tsx",
                children: /*#__PURE__*/_jsx(Freezer, {
                  onFreeze: function onFreeze() {
                    document.body.style.overflow = 'hidden';
                  },
                  onUnfreeze: function onUnfreeze() {
                    document.body.style.overflow = 'auto';
                  },
                  "data-element": "Freezer",
                  "data-component": "Page",
                  "data-source-file": "page.tsx",
                  children: /*#__PURE__*/_jsx(GlobalChallengePlayer, {
                    "data-element": "GlobalChallengePlayer",
                    "data-component": "Page",
                    "data-source-file": "page.tsx",
                    children: /*#__PURE__*/_jsx(EmbedShadowRoot, {
                      "data-element": "EmbedShadowRoot",
                      "data-component": "Page",
                      "data-source-file": "page.tsx",
                      children: /*#__PURE__*/_jsx(PageBlockList, {
                        siteConfig: siteConfig,
                        leafBlocks: leafBlocks,
                        "data-element": "PageBlockList",
                        "data-component": "Page",
                        "data-source-file": "page.tsx",
                        children: children
                      })
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};